import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/registro-vacinacao`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        create(queryParms) {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(params) {
            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(params)}`)
        },
    }
}